import {Directive, EventEmitter, Input, OnInit, Output, TemplateRef, ViewContainerRef} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AccountState, isOxioAdmin } from 'src/app/core/store';

@Directive({
  selector: '[appShowOxioAdmin]',
})
export class ShowOxioAdminDirective implements OnInit {
  condition: boolean;
  // TODO: pass in the isOxioAdmin boolean
  @Input() set appShowOxioAdmin(condition: boolean) {
    this.condition = condition;
  }

  isAdmin: boolean;

  constructor(
    protected templateRef: TemplateRef<any>,
    protected viewContainer: ViewContainerRef,
    private store: Store<AccountState>,
  ) {}

  ngOnInit() {
    this.checkIsAdmin();
  }

  checkIsAdmin() {
    this.store.pipe(select(isOxioAdmin), take(1)).subscribe((isOxioAdmin) => {
      if (
        (isOxioAdmin && this.condition) ||
        (!isOxioAdmin && !this.condition)
      ) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
      this.isAdmin = isOxioAdmin;
    });
  }
}
